import { createAsyncThunk } from "@reduxjs/toolkit";
import Api from "../../Config/ApiConfig";
import { toast } from "react-toastify";

export const Addpromotion = createAsyncThunk(
  "addPromotion",
  async (value, { rejectWithValue }) => {
    try {
      let info = await Api.post(`promotion`, value);
      if (info.data.status_code === 200) {
        return info.data;
      } else {
        toast.error(info.data.message);
        return rejectWithValue(info.data.message);
      }
    } catch (error) {
      const data = error.response?.data;
      const errorMessage = data?.errors?.length 
        ? data.errors.join(', ') 
        : (data?.message || error.message || "An error occurred");
      toast.error(errorMessage);
      return rejectWithValue(errorMessage);
    }
  }
);

export const GetPromotion = createAsyncThunk(
  "getPromotion",
  async (value, { rejectWithValue }) => {
    try {
      let info = await Api.get(`promotion`);
      if (info.data.status_code === 200) {
        return info.data.data;
      } else {
        toast.error(info.data.message);
        return rejectWithValue(info.data.message);
      }
    } catch (error) {
      const data = error.response?.data;
      const errorMessage = data?.errors?.length 
        ? data.errors.join(', ') 
        : (data?.message || error.message || "An error occurred");
      toast.error(errorMessage);
      return rejectWithValue(errorMessage);
    }
  }
);

export const updatePromotion = createAsyncThunk(
  "updatePromotion",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      let info = await Api.put(`promotion/${id}`, data);
      if (info.data.status_code === 200) {
        return info.data.data;
      } else {
        toast.error(info.data.message);
        return rejectWithValue(info.data.message);
      }
    } catch (error) {
      const data = error.response?.data;
      const errorMessage = data?.errors?.length 
        ? data.errors.join(', ') 
        : (data?.message || error.message || "An error occurred");
      toast.error(errorMessage);
      return rejectWithValue(errorMessage);
    }
  }
);

export const deletePromotion = createAsyncThunk(
  "DeletePromotion",
  async (id, { rejectWithValue }) => {
    try {
      let info = await Api.delete(`promotion/${id}`);
      if (info.data.status_code === 200) {
        return info.data.data;
      } else {
        toast.error(info.data.message);
        return rejectWithValue(info.data.message);
      }
    } catch (error) {
      const data = error.response?.data;
      const errorMessage = data?.errors?.length 
        ? data.errors.join(', ') 
        : (data?.message || error.message || "An error occurred");
      toast.error(errorMessage);
      return rejectWithValue(errorMessage);
    }
  }
);
